/* eslint-disable react/jsx-no-duplicate-props */
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Checkbox, Fab, InputAdornment, MenuItem, Switch, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import _ from 'lodash';

import { createSafalEventUser, globalImagesUpload, updateSafalEventUser } from '../../../services/Service';
import DateField from '../../../components/UI/DateField';
import FileImageView from '../../../components/UI/FileImageView';
import CustomSimpleSelect from '../../../components/UI/CustomSimpleSelect';
import { countryData } from '../../../utils/general';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  maxHeight: '95vh',
  overflow: 'auto',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  '@media (max-width: 640px)': {
    width: '95vw',
    height: '95vh',
    overflow: 'auto',
  },
};

// lineItem
// {
//     "itemCode": "", // optional
//     "name": "", // required
//     "quantity": 1, // required
//     "rate": 12, // required
//     "grossAmount": 12, // required
//     // "uom":"", // required
//     // "isWarranty":"", // optional true/false
//     // "warranty":"", // optional safalWarranty id
// }

// {
//   "event": "67c72fa78df75a7fb4da098e", // required pass event id
//   "billNumber": "DAADAS232121", // required
//   "store": "Hello Store", // required
//   "invoiceDate": "2024-12-06T14:57:17.375+00:00", // optional date ISO format
//   "description": "description 1234", // optional
//   "country": "", // optional
//   "state": "", // optional
//   "city": "", // optional
//   "invoiceUrls": [], // optional invoice s3 url
//   "lineItems": []
// }

const resetFieldValue = {
  event: '',
  billNumber: '',
  store: '',
  invoiceDate: '',
  description: '',
  country: '',
  state: '',
  city: '',
  invoiceUrls: [],
  lineItems: [],
};

export default function AddModalBill({ data, open, onClose, isDisplay, events }) {
  const { user } = useSelector((state) => state.login);
  // const dispatch = useDispatch();
  const eventsList = events || [];

  const [fieldValue, setFieldValue] = React.useState({ ...resetFieldValue });
  const [fieldValueError, setFieldValueError] = React.useState([]);
  const [isDisableAll, setIsDisableAll] = React.useState(false);

  const [imagesFile, setImagesFile] = React.useState(null);

  const onCloseThis = (refetchFlag) => {
    setIsDisableAll(false);
    setFieldValue({ ...resetFieldValue });
    setFieldValueError([]);
    setImagesFile(null);
    onClose(refetchFlag);
  };

  const updateFieldValue = data
    ? {
        event: data?.event?._id ?? '',
        billNumber: data?.billNumber ?? '',
        store: data?.store ?? '',
        invoiceDate: data?.invoiceDate ?? '',
        description: data?.description ?? '',
        country: data?.country ?? '',
        state: data?.state ?? '',
        city: data?.city ?? '',
        invoiceUrls: data?.invoiceUrls ?? [],
        lineItems: data?.lineItems ?? [],
      }
    : resetFieldValue;

  const handleClose = async (refetchFlag, directClose) => {
    if (isDisplay) {
      onCloseThis(refetchFlag);
      return;
    }
    if (directClose) {
      onCloseThis(refetchFlag);
      return;
    }

    if (_.isEqual(updateFieldValue, fieldValue)) {
      onCloseThis(refetchFlag);
      return;
    }
    const result = await Swal.fire({
      text: 'Are you sure you want to close this?',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
      appendTo: 'body',
      customClass: {
        container: 'my-swal', // Add a custom class for styling
      },
      onBeforeOpen: () => {
        // Set a higher zIndex for the Swal modal
        document.querySelector('.my-swal').style.zIndex = 999999;
      },
    });

    if (result.isConfirmed) {
      onCloseThis(refetchFlag);
    }
  };

  React.useEffect(() => {
    if (open === true && data !== null) {
      setFieldValue(updateFieldValue);
      setIsDisableAll(isDisplay);
    }
  }, [open, data, isDisplay]);

  const onSubmit = async () => {
    setIsDisableAll(true);
    try {
      const payload = {
        ...fieldValue,
      };

      if (imagesFile) {
        const fileRes = await globalImagesUpload([imagesFile], 'safal_event', 'private');
        if (!fileRes.data?.data?.[0]) throw new Error('upload failed');
        payload.eventImage = [fileRes.data?.data?.[0]];
      }

      const res = await createSafalEventUser(payload);
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose(true, true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onUpdate = async () => {
    setIsDisableAll(true);
    try {
      const payload = {
        ...fieldValue,
      };

      if (imagesFile) {
        const fileRes = await globalImagesUpload([imagesFile], 'safal_event', 'private');
        if (!fileRes.data?.data?.[0]) throw new Error('upload failed');
        payload.eventImage = [fileRes.data?.data?.[0]];
      }

      const res = await updateSafalEventUser({ ...payload, _id: data._id });
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose(true, true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const amountSym = user.country === 'United States' ? '$' : '₹';

  return (
    <>
      <Modal sx={{ zIndex: 345 }} open={open} onClose={handleClose}>
        <Box sx={style}>
          <Fab
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={handleClose}
            size="small"
            color="primary"
            aria-label="add"
          >
            <CloseIcon />
          </Fab>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h4" gutterBottom sx={{ fontSize: '24px', fontWeight: 700, color: '#3D71FF' }}>
              {data === null
                ? `Record your new bill `
                : isDisplay
                ? `Bill (${data?.code || ''})`
                : `Update Bill (${data?.code || ''})`}
            </Typography>
            {/* {isDisplayModeActive && (
              <TopTitleAction
                data={editData}
                onDelete={onDeleteModalInit}
                isEdit={isDisplayModeActive}
                onEdit={() => setIsDisplayModeActive(false)}
                isChangeLogVisible={onChangeLog !== undefined}
                onChangeLog={() => onChangeLog(editData)}
              />
            )} */}
          </div>
          <div className="sm-flex-direction-column" style={{ display: 'flex', gap: '16px', marginTop: '32px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: '1 1 0%' }}>
              <span style={{ fontSize: '20px', fontWeight: 700, color: '#3D71FF' }}>Bill Information</span>
              {/* billNumber */}
              <TextField
                disabled={isDisableAll}
                value={fieldValue.billNumber}
                onChange={(e) => setFieldValue({ ...fieldValue, billNumberv: e.target.value })}
                label={
                  <Typography sx={{ color: '#B6B6B6' }}>
                    Bill Number <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                size="small"
                type="text"
                fullWidth
                variant="standard"
                InputLabelProps={{
                  style: { color: 'black' },
                  // shrink: true,
                }}
                error={fieldValueError?.find((e) => e.key === 'billNumber')}
                helperText={fieldValueError?.find((e) => e.key === 'billNumber')?.error}
                inputProps={{
                  maxlength: 250,
                }}
              />
              {/* description */}
              <TextField
                disabled={isDisableAll}
                value={fieldValue.description}
                onChange={(e) => setFieldValue({ ...fieldValue, description: e.target.value })}
                label={<Typography sx={{ color: '#B6B6B6' }}>Description</Typography>}
                size="small"
                type="text"
                fullWidth
                variant="standard"
                InputLabelProps={{
                  style: { color: 'black' },
                  // shrink: true,
                }}
                inputProps={{
                  maxlength: 500,
                }}
                error={fieldValueError?.find((e) => e.key === 'description')}
                helperText={fieldValueError?.find((e) => e.key === 'description')?.error}
              />
              {/* invoiceDate */}
              <DateField
                disabled={isDisableAll}
                value={fieldValue.invoiceDate}
                fullWidth
                variant="standard"
                label={
                  <Typography sx={{ color: '#B6B6B6' }}>
                    Invoice Date <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                onChange={(e) => e?.isValid() && setFieldValue((prev) => ({ ...prev, invoiceDate: e.toISOString() }))}
                error={fieldValueError?.find((e) => e.key === 'invoiceDate')}
                helperText={fieldValueError?.find((e) => e.key === 'invoiceDate')?.error}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: '1 1 0%' }}>
              <span style={{ fontSize: '20px', fontWeight: 700, color: '#3D71FF' }}>Purchase Location</span>
              {/* store */}
              <TextField
                disabled={isDisableAll}
                value={fieldValue.store}
                onChange={(e) => setFieldValue({ ...fieldValue, store: e.target.value })}
                label={<Typography sx={{ color: '#B6B6B6' }}>Store</Typography>}
                size="small"
                type="text"
                fullWidth
                variant="standard"
                InputLabelProps={{
                  style: { color: 'black' },
                  // shrink: true,
                }}
                error={fieldValueError?.find((e) => e.key === 'store')}
                helperText={fieldValueError?.find((e) => e.key === 'store')?.error}
                inputProps={{
                  maxlength: 250,
                }}
              />
              {/* country */}
              <CustomSimpleSelect
                variant="standard"
                disabled={isDisableAll}
                label={
                  <Typography sx={{ color: '#B6B6B6' }}>
                    Country <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                value={fieldValue.country}
                onChange={(value) => setFieldValue({ ...fieldValue, country: value })}
                valueKey="iso3"
                options={countryData?.map((e) => ({
                  label: e?.country,
                  ...e,
                }))}
                error={fieldValueError?.find((e) => e.key === 'country')}
                helperText={fieldValueError?.find((e) => e.key === 'country')?.error}
              />
              {/* state */}
              <TextField
                disabled={isDisableAll}
                value={fieldValue.state}
                onChange={(e) => setFieldValue({ ...fieldValue, state: e.target.value })}
                label={<Typography sx={{ color: '#B6B6B6' }}>State</Typography>}
                size="small"
                type="text"
                fullWidth
                variant="standard"
                InputLabelProps={{
                  style: { color: 'black' },
                }}
                // helperText={`${fieldValue.comments.length}/${250}`}
                inputProps={{
                  maxlength: 100,
                }}
              />
              {/* city */}
              <TextField
                disabled={isDisableAll}
                value={fieldValue.city}
                onChange={(e) => setFieldValue({ ...fieldValue, city: e.target.value })}
                label={<Typography sx={{ color: '#B6B6B6' }}>City</Typography>}
                size="small"
                type="text"
                fullWidth
                variant="standard"
                InputLabelProps={{
                  style: { color: 'black' },
                }}
                // helperText={`${fieldValue.comments.length}/${250}`}
                inputProps={{
                  maxlength: 100,
                }}
              />
              {/* event */}
              <CustomSimpleSelect
                variant="standard"
                disabled={isDisableAll}
                label={
                  <Typography sx={{ color: '#B6B6B6' }}>
                    Event <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                value={fieldValue.event}
                onChange={(value) =>
                  setFieldValue({
                    ...fieldValue,
                    event: value || '',
                  })
                }
                valueKey="_id"
                options={eventsList?.map((e) => ({
                  label: e?.name,
                  ...e,
                }))}
                error={fieldValueError?.find((e) => e.key === 'event')}
                helperText={fieldValueError?.find((e) => e.key === 'event')?.error}
              />
              {/* invoiceUrls */}
              <TextField
                onChange={(e) => {
                  if (!e?.target?.files[0]?.name?.match(/\.(jpg|jpeg|png|pdf)$/)) {
                    toast.error('Please select a valid file in JPG, JPEG, PNG, Format ONLY.');
                  } else {
                    setImagesFile(e.target.files[0]);
                  }
                }}
                label={<Typography sx={{ color: '#B6B6B6' }}>Upload Invoice</Typography>}
                type="file"
                size="small"
                id="upload-file-invoiceFile"
                fullWidth
                variant="standard"
                disabled={isDisableAll}
                InputProps={{
                  accept: 'image/*,.pdf',
                }}
                InputLabelProps={{
                  style: { color: 'black' },
                  shrink: true,
                }}
              />
              <FileImageView
                file={imagesFile}
                url={fieldValue.invoiceUrls?.[0] || ''}
                onRemove={() => {
                  setImagesFile(null);
                  setFieldValue({ ...fieldValue, invoiceUrls: [] });
                  const ele = document.getElementById('upload-file-invoiceFile');
                  if (ele) {
                    ele.value = null;
                  }
                }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '22px', justifyContent: 'end' }}>
            <Button
              disabled={isDisplay ? false : isDisableAll}
              sx={{
                backgroundColor: '#ff4842',
                ':hover': { backgroundColor: '#d40700' },
                color: 'white',
                borderRadius: '30px',
                textTransform: 'capitalize',
              }}
              onClick={handleClose}
              variant="contained"
            >
              Cancel
            </Button>
            {!isDisplay && data === null && (
              <Button
                disabled={isDisableAll}
                onClick={onSubmit}
                sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                variant="contained"
              >
                Add
              </Button>
            )}
            {!isDisplay && data !== null && (
              <Button
                disabled={isDisableAll}
                onClick={onUpdate}
                sx={{ backgroundColor: '#3D71FF', borderRadius: '30px', textTransform: 'capitalize' }}
                variant="contained"
              >
                Save
              </Button>
            )}
          </div>
        </Box>
      </Modal>
    </>
  );
}
